import { TextInput as CarbonTextInput, Checkbox as CarbonCheckbox, ComboBox as CarbonCombobox, RadioButton as CarbonRadioButton, SkeletonPlaceholder as CarbonSkeletonPlaceholder, Toggle as CarbonToggle, ToggleSmall as CarbonToggleSmall } from 'carbon-components-react';
;
;
;
;
;
;
;
export var TextInput = CarbonTextInput;
export var Checkbox = CarbonCheckbox;
export var ComboBox = CarbonCombobox;
export var RadioButton = CarbonRadioButton;
export var SkeletonPlaceholder = CarbonSkeletonPlaceholder;
export var Toggle = CarbonToggle;
export var ToggleSmall = CarbonToggleSmall;
//# sourceMappingURL=Carbon.js.map